module.exports = __webpack_public_path__ + "static/media/Icon-location-on.c7417728.svg";